import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function parseDateTimeAndTimeZoneToDayjs(
  date: string, // YYYY-MM-DD
  time: string, // HH:mm (24 hours)
  timeZone: string, // IANA time zone (eg 'America/New_York')
): Dayjs {
  return dayjs.tz(`${date} ${time}`, timeZone);
}
